import ObjectFilterSelect from 'automation-ui-log-events/components/ObjectFilterSelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import * as localStorageActions from 'automation-ui-canvas/actions/LocalStorageActions';
import { getPreviouslyTestedObjectId } from 'automation-ui-canvas/selectors/localStorageSelectors';
import { useEffect } from 'react';
import * as LocalStorageKeys from 'automation-ui-canvas/constants/LocalStorageKeys';
import PortalIdParser from 'PortalIdParser';
import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import useSingleActionTest from 'automation-ui-canvas/components/panels/debugger-panel/useSingleActionTest';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContainer = styled(UIFlex).withConfig({
  displayName: "DebuggerPanelSourceSelectBody__StyledContainer",
  componentId: "sc-1ia4pq9-0"
})(["background:", ";"], GYPSUM);
export const DebuggerPanelSourceSelectBody = ({
  flowObjectTypeId,
  onObjectIdSelected,
  objectId,
  previouslyTestedObject,
  mergeDeepWithLocalStorage,
  actionId,
  flow
}) => {
  var _action$getActionType;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const action = actionId ? flow.getActionById(Number(actionId)) : undefined;
  const actionTypeId = (_action$getActionType = action === null || action === void 0 ? void 0 : action.getActionTypeId()) !== null && _action$getActionType !== void 0 ? _action$getActionType : queryParams.get('actionTypeId');
  const {
    onUpdateAction,
    stagedAction
  } = useSingleActionTest({
    actionId: actionId,
    actionTypeId
  });
  const handleObjectIdSelected = newObjectId => {
    const portalId = PortalIdParser.get();
    onObjectIdSelected(newObjectId);
    if (previouslyTestedObject && (action || stagedAction)) {
      // Simply mark the action as needing to be tested again
      onUpdateAction(stagedAction);
    }
    mergeDeepWithLocalStorage({
      [`${LocalStorageKeys.PREVIOUSLY_TESTED_OBJECT_ID}-${portalId}`]: {
        objectId: newObjectId,
        objectTypeId: flowObjectTypeId
      }
    });
  };
  useEffect(() => {
    if (previouslyTestedObject && flowObjectTypeId === previouslyTestedObject.objectTypeId) {
      onObjectIdSelected(previouslyTestedObject.objectId);
    }
  }, [previouslyTestedObject, onObjectIdSelected, flowObjectTypeId]);
  return /*#__PURE__*/_jsx(StyledContainer, {
    className: "p-y-4 p-x-4",
    align: "stretch",
    direction: "column",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: "m-bottom-2",
      justify: "between",
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "debuggerPanel.sourceSelect.inputTitle"
        })
      }), /*#__PURE__*/_jsx(ObjectFilterSelect, {
        flowObjectTypeId: flowObjectTypeId,
        updateUrlFilters: ({
          target: {
            value
          }
        }) => {
          handleObjectIdSelected(Number(value));
        },
        selectedObjectId: objectId,
        "data-test-id": "test-enroll-object-dropdown",
        extraSelectProps: {
          buttonUse: 'form-on-dark'
        }
      })]
    })
  });
};
export default connect(state => ({
  previouslyTestedObject: getPreviouslyTestedObjectId(state)
}), {
  mergeDeepWithLocalStorage: localStorageActions.mergeDeepWithLocalStorage
})(DebuggerPanelSourceSelectBody);